module.exports = __webpack_public_path__ + "static/media/quick_search.64af15f1.svg";